module.exports = __webpack_public_path__ + "static/media/welcome-modal-managers.01fa2d84.jpg";